import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-cap-plugins',
	templateUrl:'./PluginModelPage.html',
	styles: [],
	styleUrls:['./PluginModelPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		WaCardDirective,
],
	standalone:true
})
export class PluginModelPage
{
}
